import { authAPIUrl } from "@/environment";
import { TeamService } from "@/services/team.service";

import { catched } from "./catched";

export class TeamHandler {
  constructor() {
    this.teamService = new TeamService(authAPIUrl);
  }

  createTeam(name, description, members, artId, external = false) {
    return this.teamService.createTeam(name, description, members, artId, external); // not catched -> error is exposed via FeedbackButton
  }

  deleteTeam(teamId) {
    return catched(this.teamService.deleteTeam(teamId));
  }

  archiveTeam(teamId) {
    return catched(this.teamService.archiveTeam(teamId));
  }

  async getTeams({ order, external } = {}) {
    return catched(this.teamService.getTeams(order, external));
  }

  updateTeam(teamId, name, description, members, artId) {
    return this.teamService.updateTeam(teamId, name, description, members, artId); // not catched -> error is exposed via FeedbackButton
  }

  updateOidcMapping(teamId, group, role) {
    return this.teamService.updateOIDCMapping(teamId, group, role); // not catched -> error is exposed via FeedbackButton
  }

  search(name, external) {
    return catched(this.teamService.search(name, external));
  }

  getTeamMembers(teamId) {
    return catched(this.teamService.getTeamMembers(teamId));
  }

  getTeam(teamId) {
    return catched(this.teamService.getTeamById(teamId));
  }

  addTeamLicense(teamId) {
    return catched(this.teamService.addTeamLicense(teamId));
  }

  removeTeamLicense(teamId) {
    return catched(this.teamService.removeTeamLicense(teamId));
  }
}
